export default Object.freeze({
  Customer: 1,
  Payment: 2
});
